import {Tab} from "@headlessui/react";
import React, {useState} from "react";
import ImmobilieMieten from "./ImmobilieMieten";
import ImmobilieKaufen from "./ImmobilieKaufen";
import {objects} from "../../models/objects";
import {cities} from "../../models/cities";
import {useTranslation} from "next-i18next";

interface FindImmobilieFormProps {
}

enum TabsEnum {
	RENT,
	BUY
}

function FindImmobilieForm(props: FindImmobilieFormProps) {
	const {t} = useTranslation();
	const tabs = [
		t("components.findImmobilieForm.rentObject"),
		t("components.findImmobilieForm.buyObject")
	];
	const [selectedTab, setSelectedTab] = useState<TabsEnum>(TabsEnum.RENT);
	return (
		<div className="relative">
			<div
				className="lg:absolute w-[95%] xl:w-10/12 -top-[8vh] sm:-top-[15vh] left-0 right-0 mx-auto z-10 -mt-[80px] lg:mt-0"
				id="upperComponent"
			>
				<Tab.Group
					selectedIndex={selectedTab}
					onChange={(value) => {
						setSelectedTab(value === 0 ? TabsEnum.RENT : TabsEnum.BUY);
					}}
				>
					<Tab.List className={`w-auto flex justify-start`}>
						{tabs.map((tab) => (
							<Tab
								key={tab}
								className={`${
									selectedTab === tabs.indexOf(tab)
										? "bg-white text-black"
										: "bg-[#b8aa95] text-white"
								} w-fit px-[12px] py-[15px] lg:py-[26px] lg:px-[20px] shadow-inner rounded-tl-[20px] rounded-tr-[20px] mr-1 uppercase font-bold focus:outline-none text-[8px] sm:text-[12px] lg:text-[16px]`}
							>
								{tab}
							</Tab>
						))}
					</Tab.List>
					<Tab.Panels className={"bg-white rounded-[20px] rounded-tl-none"}>
						<Tab.Panel>
							<ImmobilieMieten/>
						</Tab.Panel>
						<Tab.Panel>
							<ImmobilieKaufen/>
						</Tab.Panel>
					</Tab.Panels>
				</Tab.Group>
			</div>
		</div>
	);
}

export default FindImmobilieForm;
